/**
 * viennaLocation.js — Maps Hostaway listing addresses to Vienna districts
 * and nearest public-transit stops. Provides long-tail SEO content for
 * each apartment detail page.
 *
 * Why a manual map? Hostaway returns only street + city, not district or
 * transit info. Since we have a small set of buildings, a hardcoded
 * lookup is the fastest, most accurate way to surface this data.
 */

const LOCATION_DATA = {
  // Redtenbachergasse 54 — Ottakring (16th district)
  redtenbachergasse: {
    district: "16. Bezirk – Ottakring",
    districtShort: "Ottakring",
    transit: [
      { name: "U3 Ottakring", type: "Metro", walkMinutes: 5 },
      { name: "Straßenbahn 2 (Ottakring)", type: "Tram", walkMinutes: 3 },
      { name: "Straßenbahn 44 (Maroltingergasse)", type: "Tram", walkMinutes: 4 },
    ],
    nearby: [
      "Brunnenmarkt (1,2 km – einer der größten Straßenmärkte Wiens)",
      "Yppenplatz (gastronomisches Zentrum, 1 km)",
      "Wilhelminenberg + Schloss (3 km, ideal für Spaziergänge)",
    ],
    description:
      "Ruhiges Wohnviertel in Ottakring mit ausgezeichneter Verkehrsanbindung. Die U3 bringt Sie in 12 Minuten zum Stephansplatz, die historische Altstadt ist also bequem erreichbar.",
  },
  // Obermüllnerstraße 4 — Brigittenau (20th district)
  obermuellnerstrasse: {
    district: "20. Bezirk – Brigittenau",
    districtShort: "Brigittenau",
    transit: [
      { name: "U4 Friedensbrücke", type: "Metro", walkMinutes: 4 },
      { name: "U6 Dresdner Straße", type: "Metro", walkMinutes: 8 },
      { name: "Straßenbahn 31", type: "Tram", walkMinutes: 3 },
    ],
    nearby: [
      "Donaukanal-Promenade (5 Min – Sommer-Lieblingsspot der Wiener)",
      "Augarten + Porzellanmanufaktur (10 Min Fußweg)",
      "Karmelitermarkt im 2. Bezirk (15 Min, hipper Wochenmarkt)",
    ],
    description:
      "Modern entwickeltes Quartier in der Brigittenau, direkt am Donaukanal. Die U4 verbindet Sie in 6 Minuten mit dem Schottenring und in 10 Minuten mit dem Stadtzentrum.",
  },
};

/**
 * Lookup Vienna location metadata by listing address.
 * Returns null if the address is unknown — caller should gracefully omit
 * the location section in that case.
 */
export function getViennaLocation(address) {
  if (!address) return null;
  const normalized = address.toLowerCase();
  if (normalized.includes("redtenbachergasse")) return LOCATION_DATA.redtenbachergasse;
  if (normalized.includes("obermüllnerstraße") || normalized.includes("obermullnerstrasse")) {
    return LOCATION_DATA.obermuellnerstrasse;
  }
  return null;
}
